'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  PORTAL: 'portalTz',
  USER: 'userTz',
  UTC: 'utc'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.233/js/constants/TimezoneTypes.js
// module id = 293
// module chunks = 0